<template>
  <div>
    <Banner theme="purple">
      <template v-slot:title> Faqs </template>
      <template v-slot:description>
        An FAQ is a list of frequently-asked questions.
      </template>
      <template v-slot:image>
        <img
          src="@/assets/banners/widgets/countdowns.svg"
          alt="FAQs"
        />
      </template>
    </Banner>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New FAQ"
      btn-to="/widgets/faqs/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search FAQs"
      :search-text.sync="searchText"
    />

    <div v-if="list">
      <FaqsDataTable
        v-if="computedList.length"
        :list="computedList"
        @destroy="destroy"
        @duplicate="duplicate"
      />
      <div v-else class="no-entries">No FAQs</div>
    </div>
    <Spinner v-else relative />
  </div>
</template>

<script>
import IndexPage from '../index-page';
import FaqsDataTable from '@/components/dataview/faqs.datatable';

export default {
  name: 'WidgetsFaqsPage',
  components: { FaqsDataTable },
  extends: IndexPage,
  methods: {
    async fetchList() {
      const { data } = await this.$api.Faq.get({
        sort_by: this.sortBy,
      });
      this.list = data;
    },
    async destroy(item) {
      const confirmed = await this.$confirm({ title: 'Are you sure?' });
      if (!confirmed) return;
      await this.$api.Faq.destroy({ id: item.id });
      this.list = this.list.filter((t) => t.id != item.id);
    },
    async duplicate(item) {
      await this.$api.Faq.duplicate({ id: item.id });
      this.fetchList();
    },
  },
};
</script>

<style scoped lang="scss"></style>
